<div class="cx-summary-heading">
  {{ 'orderCost.orderSummary' | cxTranslate }}
</div>

@if (cart$ | async; as cart) {
  <div class="cx-summary-partials">
    @if (vendorEntryGroups$ | async; as vendorGroups) {
      @for (vendorGroup of vendorGroups; track vendorGroup; let i = $index) {
        <ng-container
        *ngTemplateOutlet="segment; context: {vendorGroup: vendorGroup, index: i, total: false, cart: cart}"></ng-container>
      }
    }
    <ng-container *ngTemplateOutlet="segment; context: {total: true, cart:cart};"></ng-container>
    @if (entries$ | async; as entries) {
      @if (entries.length && !isRestricted && !isCheckout) {
        <button [routerLink]="{ cxRoute: 'checkout' } | cxUrl"
          class="btn btn-secondary btn-block" type="button">
          {{ 'uigCartDetails.proceedToCheckout' | cxTranslate }}
        </button>
      }
    }
    <ng-template #cartWithoutNet>
      <div class="cx-summary-row">
        {{ cart.totalPriceWithTax?.value !== cart.totalPrice?.value ? ('orderCost.grossTax' | cxTranslate) :
        ('orderCost.grossIncludeTax' | cxTranslate) }}
        {{ cart.totalTax?.formattedValue }}.
      </div>
    </ng-template>
    <ng-template #segment let-vendorGroup="vendorGroup" let-i="index" let-total="total" let-cart="cart">
      <div class="summary-segment">
        <div class="cx-summary-row" [ngClass]="total ? 'bold': ''">
          <div class="col-12 cx-summary-label">
            {{ total ? (('vendorGroups.orderTotal' | cxTranslate)+":"): (('vendorGroups.vendor' | cxTranslate)+": " +
            vendorGroup.vendorName)}}
          </div>
        </div>
        <div class="cx-summary-row">
          <div class="col-8 cx-summary-label">
            {{'vendorGroups.numberOfEntries' | cxTranslate}}:
          </div>
          <div class="col-4 cx-summary-amount">
            {{ total ? cart.entries?.length : vendorGroup.entries?.length }}
          </div>
        </div>
        <div class="cx-summary-row">
          <div class="col-8 cx-summary-label">
            {{'vendorGroups.numberOfPieces' | cxTranslate}}:
          </div>
          <div class="col-4 cx-summary-amount">
            {{total ? cart.totalUnitCount : vendorGroup.quantity }}
          </div>
        </div>
        <div class="cx-summary-row" [ngClass]="total ? 'bold': ''">
          <div class="col-8 cx-summary-label">
            {{ total ? ('vendorGroups.cartTotal' | cxTranslate) : ('vendorGroups.vendorTotal' | cxTranslate)}}:
          </div>
          <div class="col-4 cx-summary-amount">
            {{ total ? cart.totalPriceWithTax?.formattedValue : vendorGroup.totalPrice?.value | currency:vendorGroup.totalPrice?.currencyIso:"symbol":"1.2-2":"de"}}
          </div>
        </div>
        @if (!(pickup$ | async) && !(directDeliveryMode$ | async)) {
          <div class="cx-summary-row" [ngClass]="total ? 'bold': ''">
            <div class="col-8 cx-summary-label">
              {{'vendorGroups.deliveryCost' | cxTranslate}}
            </div>
            <div class="col-4 cx-summary-amount">
              {{ total ? cart.deliveryCost?.formattedValue : vendorGroup.deliveryCost?.value | currency:vendorGroup.deliveryCost?.currencyIso:"symbol":"1.2-2":"de"}}
            </div>
          </div>
        }
        @if ((pickup$ | async)) {
          <div class="cx-summary-row" [ngClass]="total ? 'bold': ''">
            <div class="col-8 cx-summary-label">
              {{'vendorGroups.deliveryCost' | cxTranslate}}
            </div>
            <div class="col-4 cx-summary-amount">
              {{ 0 | currency:"EUR":"symbol":"1.2-2":"de"}}
            </div>
          </div>
        }
        @if ((directDeliveryMode$ | async) && !(pickup$ | async)) {
          <div class="cx-summary-row" [ngClass]="total ? 'bold': ''">
            <div class="col-8 cx-summary-label">
              {{ 'vendorGroups.deliveryCost' | cxTranslate }}
            </div>
            <div class="col-4 cx-summary-amount">
              {{ cart.deliveryCostDirectTotal?.formattedValue }}
            </div>
          </div>
        }
      </div>
    </ng-template>
  </div>
}